import FederationConfig from "./federationConfig";
import Vue from "vue";
import Vuetify from "vuetify";
import minifyTheme from "minify-css-string";
import i18next from "i18next";
import { iconAliases } from "./vuetifyIconAliases";
Vue.use(Vuetify);

const vuetifyOptions = {
  theme: {
    options: {
      customProperties: true,
      minifyTheme
    },
    themes: FederationConfig.colors
  },
  icons: {
    values: iconAliases
  },
  lang: {
    t: (key, ...params) => i18next.t(key, params)
  }
};

export default new Vuetify(vuetifyOptions);
